/**
 * @generated SignedSource<<8dde9ccec1f7e894d4c1c997f8256f21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CrmListModeEnum = "FILTER" | "HANDPICK" | "IMPORT";
export type CrmListTypeEnum = "CONTACT";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
import { FragmentRefs } from "relay-runtime";
export type CrmList_Single_Fragment$data = {
  readonly author: {
    readonly node: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly slug: string | null | undefined;
      readonly username: string | null | undefined;
    };
  } | null | undefined;
  readonly content: string | null | undefined;
  readonly created: string | null | undefined;
  readonly crmListToItems: {
    readonly count: number | null | undefined;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly contact: {
          readonly node: {
            readonly company: string | null | undefined;
            readonly country: string | null | undefined;
            readonly created: string | null | undefined;
            readonly databaseId: number | null | undefined;
            readonly email: string;
            readonly firstname: string | null | undefined;
            readonly formEntries: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly created: string | null | undefined;
                  readonly form: {
                    readonly node: {
                      readonly content: string | null | undefined;
                      readonly title: string;
                    };
                  } | null | undefined;
                  readonly marketingConsent: boolean;
                };
              }>;
            } | null | undefined;
            readonly id: string;
            readonly ids: ReadonlyArray<string | null | undefined> | null | undefined;
            readonly jobTitle: string | null | undefined;
            readonly lastname: string | null | undefined;
            readonly modified: string | null | undefined;
          };
        } | null | undefined;
        readonly created: string | null | undefined;
        readonly id: string;
        readonly itemId: string | null | undefined;
        readonly listId: string | null | undefined;
        readonly mode: CrmListModeEnum | null | undefined;
        readonly modified: string | null | undefined;
        readonly type: CrmListTypeEnum;
      };
    }>;
  } | null | undefined;
  readonly id: string;
  readonly status: PostStatusEnum | null | undefined;
  readonly statusSettings: {
    readonly approved: {
      readonly id: string | null | undefined;
      readonly timestamp: string | null | undefined;
      readonly user: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly stateWhenApproved: {
      readonly status: PostStatusEnum | null | undefined;
      readonly uiPermission: {
        readonly type: StatusUiPermissionEnum | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly status: PostStatusEnum | null | undefined;
    readonly uiPermission: {
      readonly type: StatusUiPermissionEnum | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly title: string;
  readonly type: CrmListTypeEnum | null | undefined;
  readonly " $fragmentType": "CrmList_Single_Fragment";
};
export type CrmList_Single_Fragment$key = {
  readonly " $data"?: CrmList_Single_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CrmList_Single_Fragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modified",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CrmList_Single_Fragment",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusSettings",
      "kind": "LinkedField",
      "name": "statusSettings",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StateWhenApproved",
          "kind": "LinkedField",
          "name": "stateWhenApproved",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ApprovedState",
          "kind": "LinkedField",
          "name": "approved",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timestamp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v6/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NodeWizAuthorToUserConnectionEdge",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "CrmListToCrmListToItemsConnection",
      "kind": "LinkedField",
      "name": "crmListToItems",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CrmListToCrmListToItemsConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CrmListToItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "listId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemId",
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mode",
                  "storageKey": null
                },
                (v7/*: any*/),
                (v8/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CrmListToItemToContactConnectionEdge",
                  "kind": "LinkedField",
                  "name": "contact",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Contact",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "databaseId",
                          "storageKey": null
                        },
                        (v7/*: any*/),
                        (v8/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstname",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastname",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "company",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "country",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "ids",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobTitle",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ContactToFormEntriesConnection",
                          "kind": "LinkedField",
                          "name": "formEntries",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ContactToFormEntriesConnectionEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "FormEntry",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "marketingConsent",
                                      "storageKey": null
                                    },
                                    (v7/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "FormEntryToFormConnectionEdge",
                                      "kind": "LinkedField",
                                      "name": "form",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "Form",
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            (v1/*: any*/),
                                            (v3/*: any*/)
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "crmListToItems(first:100)"
    }
  ],
  "type": "CrmList",
  "abstractKey": null
};
})();

(node as any).hash = "e16b01f9a3491d3e59c2c9e54ea752cf";

export default node;
